import Component from '@ember/component';
import { action, computed, get, getProperties } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';

/* attrs
  - report
  - field
  - onlyEditCompleted - boolean
    - if true then can only edit the completed property
    - default is false
*/
export default Component.extend({
  coachingService: service(),

  report: null,
  field: null,
  onlyEditCompleted: false,
  fieldId: alias('field.id'),
  fieldType: alias('field.t'),

  tasks: computed('report.id', 'field.id', function () {
    let { report, field } = getProperties(this, 'report', 'field');
    return this.coachingService.getFieldValue(field, report);
  }),

  didInsertElement() {
    this._super(...arguments);
    if (get(this, 'tasks.length') === 0) {
      this.send('addTask');
    }
  },

  addTask: action(function () {
    this.tasks.push({
      completed: false,
      l: '',
    });
  }),

  removeTask: action(function (task) {
    this.tasks = this.tasks.filter(t => t !== task);
  }),
});
